import { ReportDTO } from '@nx-smartmonkey/shared/domain';
import { StopReport, StopReportDTO } from '../domain/stops/StopReport';

export class StopReportMapper {
  static toDomain(props: ReportDTO): StopReport {
    const { id, stop_id, created_at, type, comments, images, signature, custom_fields } = props;

    return StopReport.create(
      {
        stop_id,
        type,
        comments: (comments ?? ``) !== ``,
        images: (images ?? []).length > 0 ? true : false,
        signature: signature ? true : false,
        custom_fields: custom_fields && Object.keys(custom_fields).length > 0 ? true : false,
        tasks_completed: props.tasks.filter((task) => task.status === `completed`).length,
        tasks_total: props.tasks.length,
        created_at,
      },
      id
    );
  }

  static toRepository(report: StopReport): StopReportDTO {
    return {
      id: report.id,
      stop_id: report.stop_id,
      type: report.type,
      comments: report.comments,
      images: report.images ? [] : undefined,
      signature: report.signature,
      custom_fields: report.custom_fields ? {} : undefined,
      created_at: report.created_at,
    };
  }
}
